<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('mkv-to-mp3-converter', 'MKV → MP3');

function handleBatchCreated(batchId: string) {
  console.log('[MKV-to-MP3 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[MKV-to-MP3 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[MKV-to-MP3 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[MKV-to-MP3 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[MKV-to-MP3 Converter] Credits updated:', credits);
}
</script>
